export default "__VITE_ASSET__BVULIujP__"